<template>
    <vx-action-icon
        :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'"
        class="mr-4"
        @click="goBack"
    />
</template>

<script>
export default {
    name: 'vx-back-button',
    methods: {
        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>
